import { render } from "./Expect.vue?vue&type=template&id=605f1c67&scoped=true&ts=true"
import script from "./Expect.vue?vue&type=script&lang=ts"
export * from "./Expect.vue?vue&type=script&lang=ts"

import "./Expect.vue?vue&type=style&index=0&id=605f1c67&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605f1c67"]])

export default __exports__